import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { QueryParamModule } from '@core-mkt/services/query-param/query-param.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { VisionVideoButtonComponent } from './vision-video-button/vision-video-button.component';

@NgModule({
  exports: [VisionVideoButtonComponent],
  imports: [CommonModule, FontAwesomeModule, QueryParamModule, VisionVideoButtonComponent],
})
export class VisionVideoButtonModule {}
